export default "__VITE_ASSET__CQqbEcv6__"